module.exports = __webpack_public_path__ + "fonts/02aa6e7b39da1ff77803f67452addc43-Roboto-Medium.eot";